import {
  ALERT_MODAL,
  SET_SIDEBAR_STATUS,
  ADD_GYM_MODAL,
  ADD_TRAINER_MODAL,
  ADD_MEMBER_MODAL,
  ADD_USER_MODAL,
  SET_RETAIL_MODAL,
  ADD_PRIVATE_MODAL,
  ADD_WOD_MODAL,
  ADD_PACKAGE_MODAL,
  ADD_SALE_MODAL,
  ADD_STAFF_MODAL,
  ADD_APPOINTMENT_MODALL,
  COLLAPSE_SIDE_BAR,
} from "../../actions/types/types";

const initState = {
  sidebarStatus: false,
  // gymModal:false,
  trainerModal: false,
  userModal: false,
  retailModal:false,
  privateModal: false,
  wodModal: false,
  memberModal: false,
  alertModal: false,
  packageModal: false,
  packageEdit: false,
  pacakageFields: {},
  saleModal: false,
  saleEdit: false,
  saleField: {},
  staffModal: false,
  staffEdit: false,
  staffFields: {},
  appointmentModal: false,
  appointmentEdit: false,
  serviceModal: false,
  collapsed: false,
  gateModal: false,
  gateEdit: false,
  gateEditFields: {},
  courtModal:false,
  workshopModal:false,
  followupProgramModal: false,
  // adminModal:false
};

const sidebarReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_SIDEBAR_STATUS:
      return {
        ...state,
        sidebarStatus: action.payload.data,
      };
    case ADD_GYM_MODAL:
      return {
        ...state,
        gymModal: action.payload.data,
      };
    case ADD_TRAINER_MODAL:
      return {
        ...state,
        trainerModal: action.payload.data,
      };
    case ADD_MEMBER_MODAL:
      return {
        ...state,
        memberModal: action.payload.data,
      };
    case ADD_USER_MODAL:
      return {
        ...state,
        userModal: action.payload.data,
      };
      case SET_RETAIL_MODAL:
        return {
          ...state,
          retailModal: action.payload.data,
        };
    case ADD_PRIVATE_MODAL:
      //console.log("In Reducer")
      return {
        ...state,
        privateModal: action.payload.data,
      };
    case "ADD_WORKSHOP_MODAL":
      //console.log("In Reducer")
      return {
        ...state,
        workshopModal: action.payload.data,
      };
      
    case ADD_WOD_MODAL:
      return {
        ...state,
        wodModal: action.payload.data,
      };
      case "SET_COURT_MODAL":
        return {
          ...state,
          courtModal: action.payload.data,
        };
    case ALERT_MODAL:
      return {
        ...state,
        alertModal: action.payload.data,
      };
    case ADD_PACKAGE_MODAL:
      return {
        ...state,
        packageModal: action.payload.data,
        packageEdit: action.payload.isEdit,
        editFields: action.payload.editFields,
      };
    case ADD_SALE_MODAL:
      return {
        ...state,
        saleModal: action.payload.data,
        saleEdit: action.payload.isEdit,
        saleField: action.payload.editFields,
      };
    case ADD_APPOINTMENT_MODALL:
      return {
        ...state,
        appointmentModal: action.payload.data,
      };
    case "ADD_SERVICE_MODAL":
      return {
        ...state,
        serviceModal: action.payload.data,
      };
    case ADD_STAFF_MODAL:
      return {
        ...state,
        staffModal: action.payload.data,
        staffEdit: action.payload.isEdit,
        staffFields: action.payload.editFields,
      };
    case COLLAPSE_SIDE_BAR:
      return {
        ...state,
        collapsed: !state.collapsed,
      };
    case "ADD_GATE_MODAL":
      return {
        ...state,
        gateModal: action.payload.data,
        gateEdit: action.payload.isEdit || false,
        gateEditFields: action.payload.editFields || {},
      };
    case "ADD_FOLLOWUP_PROGRAM_MODAL":
      return {
        ...state,
        followupProgramModal: action.payload.data,
      };
    default:
      return { ...state };
  }
};

export default sidebarReducer;
